import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { CabecalhoRomaneioCliente, RomaneioClienteDto, defaultRomaneioClienteDto } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { PedidoService } from 'src/app/faturamento/service/pedido.service';
import { FiltroPedidoCliente, getFiltroPedidoClienteDefault } from 'src/app/faturamento/interface/pedido';
import { AuthService } from 'src/app/service/auth.service';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';
import { Transportadora } from 'src/app/interface/transportadora';
import { Veiculo } from '../../romaneio/interface/veiculo';
import { VeiculoLookupService } from '../../romaneio/service/veiculo-lookup-service';
import { TransportadoraService } from 'src/app/service/transportadora-service';
import { FiltroRomaneioClienteLista } from '../../expedicao/filter/filtro-romaneio-cliente-lista';
import { GrupoClienteLookupService } from 'src/app/service/grupo-cliente-lookup-service';
import { GrupoCliente } from 'src/app/interface/grupo-cliente';
import { ClienteService } from 'src/app/service/cliente-service';
import { NgForm } from '@angular/forms';
import { AngularDeviceInformationService } from 'angular-device-information';
import { firstValueFrom } from 'rxjs';
import { ExcelService } from 'src/app/service/excel-service';
import * as moment from 'moment';

@Component({
  selector: 'app-romaneio-mercado-interno-lista',
  templateUrl: './romaneio-mercado-interno-lista.component.html',
  styleUrls: ['./romaneio-mercado-interno-lista.component.css']
})
export class RomaneioMercadoInternoListaComponent implements OnInit {

  CZ00COD: string = '';
  senhaAcesso: string = '';
  isDesktop: boolean = false;

  bloqueiaPlaca: boolean = false;

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalOriginal: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRomaneioClienteLista;

  novoCadastroRomaneio: CabecalhoRomaneioCliente;

  alteraRomaneio: RomaneioClienteDto;

  permissaoExcluir: boolean = false;
  bloqueiaAcao: boolean = true;

  advancedGrupoClienteFilters: Array<PoDynamicFormField>;
  columnsGrupoClienteFilters: Array<PoLookupColumn>;
  fieldFormaterGrupoClienteFilters: ((value: GrupoCliente) => string);

  varStatus: Array<PoSelectOption>;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  filtroPedidoCliente: FiltroPedidoCliente = getFiltroPedidoClienteDefault();

  veiculoAdvancedFilters: Array<PoDynamicFormField>;
  veiculoColumnsFilters: Array<PoLookupColumn>;
  veiculoFieldFormaterFilters: (value: Veiculo) => string;

  advancedTransportadoraFilters: Array<PoDynamicFormField>;
  columnsTransportadoraFilters: Array<PoLookupColumn>;
  fieldFormaterTransportadoraFilters: ((value: Transportadora) => string);

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private clienteService: ClienteService,
    private poStorageService: PoStorageService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private excelService: ExcelService,
    public grupoClienteLookupService: GrupoClienteLookupService,
    public veiculoLookupService: VeiculoLookupService,
    public transportadoraService: TransportadoraService,
    private deviceInformationService: AngularDeviceInformationService,
    private authService: AuthService,
  ) {

    this.tabelaPrincipalFiltro = new FiltroRomaneioClienteLista(this.poStorageService);

    this.novoCadastroRomaneio = defaultRomaneioClienteDto();
    this.alteraRomaneio = defaultRomaneioClienteDto();

    this.veiculoAdvancedFilters      = this.veiculoLookupService.getAdvancedFilter();
    this.veiculoColumnsFilters       = this.veiculoLookupService.getColumnsFilter();
    this.veiculoFieldFormaterFilters = this.veiculoLookupService.getFieldFormater;

    this.advancedTransportadoraFilters = this.transportadoraService.getAdvancedFilter();
    this.columnsTransportadoraFilters = this.transportadoraService.getColumnsFilter();
    this.fieldFormaterTransportadoraFilters = this.transportadoraService.getFieldFormater;

    this.advancedGrupoClienteFilters = this.grupoClienteLookupService.getAdvancedFilter();
    this.columnsGrupoClienteFilters = this.grupoClienteLookupService.getColumnsFilter();
    this.fieldFormaterGrupoClienteFilters = this.grupoClienteLookupService.getFieldFormater;

    this.varStatus = this.listaStatus();

    this.formatExtended = PoDatepickerIsoFormat.Extended;
  }

  @ViewChild('modalValidaSenha'     , { static: true }) modalValidaSenha!: PoModalComponent;
  @ViewChild('advancedFilterModal'  , { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('criarRomaneioModal'   , { static: true }) criarRomaneioModal!: PoModalComponent;
  @ViewChild('editarDadosEtapaModal', { static: true }) editarDadosEtapaModal!: PoModalComponent;
  @ViewChild('formValidaSenha'      , { static: true }) formValidaSenha!: NgForm;

  ngOnInit(): void {
    this.isDesktop = this.deviceInformationService.isDesktop();

    this.authService.validaPrivilegio(["PO_EXPEDICAO", "PORTAL_ADMINISTRADOR"]).then((ret) => {
      this.permissaoExcluir = !ret;
    });


    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.listaRomaneioMI(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return { ...item };
      });
      this.tabelaPrincipalOriginal = this.tabelaPrincipalItens;
      this.bloqueiaAcao = true;
    });
  }

  selecionaRegistro(): void {
    this.bloqueiaAcao = true;
    this.tabelaPrincipalOriginal.forEach((item) => {
      if (item.$selected) {
        this.bloqueiaAcao = false;
      }
    });
  }

  getRomaneiosSelecionados(): Array<any> {
    return this.tabelaPrincipalOriginal.filter((item) => item.$selected);
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ00COD'   , label: 'Código'        , width: '08%'} ,
    {property: 'DZ00DATA'  , label: 'Data'          , width: '10%'  , type: 'date'  , format: 'dd/MM/yyyy'},
    {property: 'DZ00DTACAR', label: 'Dt. Carregamento' , width: '18%'  , type: 'date'  , format: 'dd/MM/yyyy'},
    {property: 'CZ00GRPVEN', label: 'Grp Cliente'   , width: '08%'} ,
    {property: 'CACYDESCRI', label: 'Descrição'     , width: '18%'} ,
    {property: 'CA1EST'    , label: 'Destino '      , width: '18%'} ,
    {property: 'CZ00STATUS', label: 'Status'        , width: '12%'  , type: 'label' ,
      labels: [
        { value: '0', color: 'color-01',  label: 'Pend. Expedição' },
        { value: '1', color: 'color-08',  label: 'Pend. Comercial' },
        { value: '2', color: 'color-11',  label: 'A Faturar' },
        { value: '3', color: 'color-07',  label: 'Fat. sem Dados' },
        { value: '4', color: 'color-09',  label: 'A Carregar' },
        { value: '5', color: 'color-10',  label: 'Carregamento Autorizado' },
        { value: '6', color: 'color-10',  label: 'Carregado' },
        { value: 'Z', color: 'color-05',  label: 'Finalizado' },
      ]
    },
    {property: 'CZ00HORA'  , label: 'Hora'          , width: '08%'} ,
    {property: 'CEE7PEDIDO', label: 'Ped Cliente'   , width: '10%'} ,
    {property: 'CEE7PEDFAT', label: 'Ped Fat.'      , width: '10%'} ,
    {property: 'NEE7PESOLI', label: 'Peso Lim.'     , width: '10%'  , type: 'number', format: '1.2-2'},
    {property: 'NPESOTOT'  , label: 'Peso Acum.'    , width: '10%'  , type: 'number', format: '1.2-2'},
    {property: 'DZ00DTLIB' , label: 'Dt. Liberação' , width: '10%'  , type: 'date'  , format: 'dd/MM/yyyy'},
    {property: 'CZ00HRLIB' , label: 'Hr. Liberação' , width: '08%'} ,
  ];

  public readonly tabelaPrincipalAction: Array<PoTableAction> = [
    { label: 'Editar'               , icon: 'po-icon-edit'            , action: this.editar.bind(this), disabled: this.desabilitaEditar.bind(this) },
    { label: 'Etiqueta Cliente'     , icon: 'po-icon-credit-payment'  , action: this.getPDFRomaneio.bind(this) },
    { label: 'Editar Dados Etapa'   , icon: 'po-icon-clipboard'       , action: this.editarDadosEtapa.bind(this) },
    { label: 'Validar Carregamento' , icon: 'po-icon-list'            , action: this.validarDadosCarregamento.bind(this), disabled: this.desabilitaValidarCarregamento.bind(this) },
    { label: 'Excluir'              , icon: 'po-icon-delete'          , action: this.openDialogConfirmarExcluirRomaneio.bind(this), disabled: this.desabilitaExcluir.bind(this) },
    { label: 'Retorna p/ Pendente'  , icon: 'po-icon-change'          , action: this.retornarPendente.bind(this), disabled: this.desabilitaRetornarPendente.bind(this) },
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Criação Romaneio', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };


  public readonly criarRomaneioAction: PoModalAction = {
    action: () => {
      this.criarRomaneioModal.close();
      this.novoRomaneio();
    },
    label: 'Confirmar'
  };

  openModalNovoRomaneio(): void {
    this.criarRomaneioModal.open();
  }

  novoRomaneio(): void {
    this.romaneioService.criarRomaneioClienteMI(this.novoCadastroRomaneio).subscribe((ret) => {
      this.router.navigateByUrl(`/estoque/expedicao/romaneio-mi/cadastro/${ret.CZ00COD}`);
    });
  }

  desabilitaEditar(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS == 'Z';
  }

  desabilitaExcluir(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS == 'Z' || this.permissaoExcluir;
  }

  desabilitaRetornarPendente(row: CabecalhoRomaneioCliente): boolean {
    return (this.permissaoExcluir || row.CZ00STATUS == '0');
  }

  editar(row: CabecalhoRomaneioCliente): void {
    this.router.navigateByUrl(`/estoque/expedicao/romaneio-mi/cadastro/${row.CZ00COD}`);
  }

  editarDadosEtapa(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.getRomaneioClienteShort(row.CZ00COD).subscribe(romaneio => {
      this.alteraRomaneio = romaneio;

      if ((this.alteraRomaneio.CZ00STATUS === '3' || this.alteraRomaneio.CZ00STATUS === '4') ) {
        this.bloqueiaPlaca = true;
      } else {
        this.bloqueiaPlaca = false;
      }

      this.editarDadosEtapaModal.open();
    });
  }

  getPDFRomaneio(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.getPdfRomaneio(row.CZ00COD).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${row.CZ00COD}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  bttnEtiquetaClienteSelecionados(): void {
    this.getRomaneiosSelecionados().forEach((item) => {
      this.romaneioService.getPdfRomaneio(item.CZ00COD).subscribe((res) => {
        const file = new Blob([res], {type: 'application/pdf'});
        const fileName = `ROMANEIO_${item.CZ00COD}.pdf`;
        const a = document.createElement("a");
        document.body.appendChild(a);

        const fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
      });
    });
  }

  bttnExcel(): void {
    const listaExcel = this.getRomaneiosSelecionados().map((item) => {
      return {
        'Código': item.CZ00COD,
        'Data': item.DZ00DATA ? moment(item.DZ00DATA).locale('pt-br').format('DD/MM/YYYY') : '',
        'Dt. Carregamento': item.DZ00DTACAR ? moment(item.DZ00DTACAR).locale('pt-br').format('DD/MM/YYYY') : '',
        'Grp Cliente': item.CZ00GRPVEN,
        'Descrição': item.CACYDESCRI,
        'Status': this.getStatusName(item.CZ00STATUS),
        'Hora': item.CZ00HORA,
        'Ped Cliente': item.CEE7PEDIDO,
        'Ped Fat.': item.CEE7PEDFAT,
        'Peso Lim.': item.NEE7PESOLI,
        'Peso Acum.': item.NPESOTOT,
        'Dt. Liberação': item.DZ00DTLIB ? moment(item.DZ00DTLIB).locale('pt-br').format('DD/MM/YYYY') : '',
        'Hr. Liberação': item.CZ00HRLIB,
      };
    });

    this.excelService.exportAsExcelFile(listaExcel, 'Romaneio_MI');
  }

  getStatusName(status: string): string {
    if (status === '0') {
      return 'Pend. Expedição';
    } else if (status === '1') {
      return 'Pend. Comercial';
    } else if (status === '2') {
      return 'A Faturar';
    } else if (status === '3') {
      return 'Fat. sem Dados';
    } else if (status === '4') {
      return 'A Carregar';
    } else if (status === '5') {
      return 'Carregamento Autorizado';
      } else if (status === '6') {
      return 'Carregado';
    } else if (status === 'Z') {
      return 'Finalizado';
    } else {
      return '';
    }
  }

  openDialogConfirmarExcluirRomaneio(row: CabecalhoRomaneioCliente): void {
    this.poDialogService.confirm({
      title: 'Excluir Romaneio',
      message: 'Deseja realmente excluir o romaneio?',
      confirm: () => this.excluirRecebimentoMercadoria(row)
    });
  }

  openDialogConfirmarExcluirRomaneiosSelecionados(): void {
    this.poDialogService.confirm({
      title: 'Excluir Romaneios',
      message: 'Deseja realmente excluir os romaneios selecionados?',
      confirm: () => this.excluirRomaneiosSelecionados()
    });
  }


  excluirRecebimentoMercadoria(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.excluirRomaneio(row.CZ00COD).subscribe( () => {
      this.tabelaPrincipalLoad();
    });
  }

  async excluirRomaneiosSelecionados(): Promise<void> {
    let excluiuRomaneio = false;

    for (const item of this.getRomaneiosSelecionados()) {
      if (item.CZ00STATUS === 'Z') {
        this.poNotificationService.warning(`O romaneio ${item.CZ00COD} não será excluído pois já está Finalizado.`);
      } else {
        excluiuRomaneio = true;
        await firstValueFrom(this.romaneioService.excluirRomaneio(item.CZ00COD));
      }
    }

    if (excluiuRomaneio) {
      this.tabelaPrincipalLoad();
    }
  }

  retornarPendente(row: CabecalhoRomaneioCliente): void {
    this.poDialogService.confirm({
      title: 'Retornar para Pendente',
      message: 'Deseja realmente voltar esse romaneio para PENDENTE?',
      confirm: () => this.retornarRomaneioPendente(row)
    });
  }

  retornarRomaneioPendente(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.retornarPendente(row.CZ00COD).subscribe( (ret) => {
      if (ret.lSuccess) {
        this.tabelaPrincipalLoad();
      } else {
        if (ret.cTipoErro == "H") {
          this.poDialogService.confirm({
            title: 'Passou do prazo',
            message: 'A nota fiscal já foi gerada, porém não é mais possível realizar o cancelamento devido ao prazo de 24h. Deseja estornar o romaneio mesmo assim?',
            confirm: () => this.forcarRetornarRomaneioPendente(row)
          });
        }
      }
    });
  }

  forcarRetornarRomaneioPendente(row: CabecalhoRomaneioCliente): void {
    this.romaneioService.forcaRetornarPendente(row.CZ00COD).subscribe( (ret) => {
      this.poNotificationService.success("Romaneio estornado com sucesso!");
      this.tabelaPrincipalLoad();
    });
  }

  validarDadosCarregamento(row: CabecalhoRomaneioCliente): void {
    if(this.isDesktop){
      this.senhaAcesso = '';
      this.CZ00COD = row.CZ00COD;
      this.modalValidaSenha.open();
    } else {
      this.router.navigateByUrl(`/estoque/expedicao/romaneio-interno/carregamento/${row.CZ00COD}/MI`);
    }
  }

  fecharModalSenha(): void {
    this.CZ00COD = '';
    this.senhaAcesso = '';
    this.modalValidaSenha.close();
  }

  confirmaModalSenha(): void {
    this.romaneioService.postValidaAcessoCarregamentoRomaneio(this.senhaAcesso).subscribe({
      next: (ret) => {
        if(ret.LAUTORIZA){
          this.router.navigateByUrl(`/estoque/expedicao/romaneio-interno/carregamento/${this.CZ00COD}/MI`);
          this.fecharModalSenha();
        } else {
          this.poNotificationService.error("Acesso negado.")
        }
      },
      error: () => {
        this.poNotificationService.error("Não foi possível verificar a senha. Favor entrar em contato com a TI.")
      }
    })
  }

  desabilitaValidarCarregamento(row: CabecalhoRomaneioCliente): boolean {
    return row.CZ00STATUS != '4';
  }

  listaStatus(): Array<PoSelectOption> {
    return [
      { value: "0", label: "Disp. Romaneio" },
      { value: "1", label: "Lib. Comercial" },
      { value: "2", label: "Pendente NFs" },
      { value: "3", label: "Fat. sem Dados" },
      { value: "4", label: "A Carregar" },
      { value: "5", label: "Carregamento Autorizado" },
      { value: "6", label: "Carregado" },
      { value: "Z", label: "Finalizado" },
    ];
  }

  public readonly salvarDadosRomaneio: PoModalAction = {
    action: () => {
      this.romaneioService.alterarDadosRomaneioCliente(this.alteraRomaneio).subscribe((ret) => {
        this.editarDadosEtapaModal.close();
      })
    },
    label: 'Salvar',
  };

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
